import { Button, Grid, TextField, Typography } from "@material-ui/core";
import React from "react";
import Footer from "../Footer";
import Header from "./Header";
import "./Contact.css";
import EmailIcon from "@material-ui/icons/Email";
import PhoneForwardedIcon from "@material-ui/icons/PhoneForwarded";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import FacebookIcon from "@material-ui/icons/Facebook";
import LanguageIcon from "@material-ui/icons/Language";

function Contact() {
  return (
    <div className="contact">
      <Header />
      <hr style={{ width: "95%", marginTop: "-30px", marginBottom: "30px" }} />
      <div className="contact1">
        <div className="contact_form">
          <Grid className="contact_form_grid" container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <div className="contact_form_left">
                <Typography
                  className="contact_form_left_text"
                  style={{ textAlign: "center" }}
                >
                  Contact Information
                  {/* <div className="icon-text">
                  
                </div> */}
                </Typography>
                <br />
                <Typography className="contact_form_left_text">
                  <EmailIcon style={{ color: "red" }} />
                  &nbsp; &nbsp; paokue77@gmail.com
                </Typography>
                <br />
                <Typography className="contact_form_left_text">
                  <PhoneForwardedIcon style={{ color: "darkgreen" }} />
                  &nbsp; &nbsp; +856-20-5539 1816
                </Typography>{" "}
                <br />
                <Typography className="contact_form_left_text">
                  <WhatsAppIcon style={{ color: "green" }} />
                  &nbsp; &nbsp; +856-20-59852498
                </Typography>{" "}
                <br />
                <Typography className="contact_form_left_text">
                  <FacebookIcon style={{ color: "blue" }} />
                  &nbsp; &nbsp; ອາປາວ ເລີຟ
                </Typography>{" "}
                <br />
                <Typography className="contact_form_left_text">
                  <LanguageIcon style={{ color: "purple" }} />
                  &nbsp; &nbsp; www.paokueSAOLONG-npr.com
                </Typography>{" "}
                <br />
                {/* <img src="./images/pao.jpg" alt="" /> */}
              </div>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <div className="contact_form_right">
                <Typography className="contact_form_right_text">
                  Email us
                </Typography>
                <br />
                <TextField
                  variant="outlined"
                  label="Your fullname"
                  size="small"
                  type="text"
                  fullWidth
                />
                &nbsp;
                <TextField
                  variant="outlined"
                  label="Your email"
                  size="small"
                  type="email"
                  fullWidth
                />
                &nbsp;
                <TextField
                  variant="outlined"
                  label="Details"
                  size="small"
                  type="text"
                  multiline
                  rows={5}
                  fullWidth
                />
                &nbsp;
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginTop: "20px", width: "150px" }}
                >
                  Send
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;

{
  /* <Header />
    <hr style={{ width: "95%", marginTop: "-30px", marginBottom: "30px" }} /> */
}
